import Component from '@glimmer/component';
import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import { HdsButton } from '@hashicorp/design-system-components/components';
import { Typography } from 'core/components';
import { boxPadding } from 'core/modifiers';

/**
 *
 * `PageHvnPeeringsConfigurationAccordionMarkCompleteAll` description here.
 *
 *
 * ```
 * <Page::HvnPeerings::ConfigurationAccordion::MarkCompleteAll
 *  @markCompleteAll={{this.markAllAsComplete}}
    @peeringMarkedComplete={{this.peeringMarkedComplete}}
 * />
 * ```
 *
 * @class PageHvnPeeringsConfigurationAccordionMarkCompleteAll
 *
 */
export default class PageHvnPeeringsConfigurationAccordionMarkCompleteAll extends Component {
  <template>
    {{#unless @peeringMarkedComplete}}
      <div {{boxPadding "lg 0 0"}}>
        <Typography class="hds-typography-body-100 hds-font-weight-regular">
          {{t
            "components.page.hvn-peerings.detail.instructions.aws.default.mark-complete-all-help-text"
          }}
        </Typography>
      </div>
    {{/unless}}
    <div {{boxPadding "lg 0 0"}}>
      <HdsButton
        @text={{t
          (concat
            "components.page.hvn-peerings.detail.instructions.aws.default."
            (unless
              @peeringMarkedComplete "mark-complete-all" "mark-incomplete-all"
            )
          )
        }}
        @color={{unless @peeringMarkedComplete "primary" "secondary"}}
        @size="medium"
        {{on "click" @markCompleteAll}}
      />
    </div>
  </template>
}
